import React from 'react';

const ReportedItems = () => {
    return (
        <div>
            Reported Items
        </div>
    );
};

export default ReportedItems;